<p class="not-found">
  <img src="./assets/images/icons/ops.png" alt="icon" >  {{'pageNotFoundBlock'|translate}}
</p>
